export enum RecurrenceIntervalType {
  minute,
  hour
}